import * as React from 'react';
import AboutLoriiniApp from '../containers/AboutLoriiniApp';

export default (props) => <AboutLoriiniApp {...props} />

